var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 463 463",
    style: {
      enableBackground: "new 0 0 463 463"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.9,248.8l39.4-71l57.4-24.6c2.4-1,4.2-3.2,4.7-5.8l8.6-42.8c0.4-2.2-0.1-4.6-1.5-6.4c-1.4-1.8-3.5-3-5.8-3.2 l-101.7-8.5l-93.2-33.9c-0.7-0.2-1.3-0.4-2-0.5L60.9,35c-1.5-0.1-3,0.2-4.3,0.8L5.2,61.6c-3.6,1.8-5.3,5.9-4,9.7l17.1,51.4 c1,3,3.7,5.1,6.8,5.5l75,7.5L87,168.6c-0.3,0.6-0.4,1.3-0.5,2l-8.4,67.2l-16.5,33c-0.8,1.5-1,3.2-0.7,4.9l8,48.3L53.5,347 c-2.3,3.5-1.6,8.1,1.7,10.7l42.5,34l33.9,34c1.5,1.6,3.6,2.4,5.7,2.4c1.4,0,2.8-0.4,4.1-1.1l41.3-24.8l83.9-8.4 c2.2-0.2,4.3-1.4,5.6-3.2l24-32l31.5-7.9c3-0.8,5.3-3.2,5.9-6.2l7.9-39.6l22.9-15.3c3.4-2.2,4.5-6.7,2.7-10.3L351.9,248.8z  M329.8,293.4c-1.8,1.2-3,3-3.4,5.1l-7.6,37.8l-29.3,7.3c-1.8,0.4-3.4,1.5-4.5,3l-23.6,31.4l-82.2,8.2c-1.2,0.1-2.3,0.5-3.3,1.1 l-37.5,22.5L108.7,380c-0.2-0.2-0.4-0.4-0.7-0.6l-37.1-29.7l13-19.6c1.1-1.7,1.6-3.8,1.2-5.8l-8.1-48.8l16-31.9 c0.4-0.8,0.7-1.7,0.8-2.6l8.4-67.5l16.7-41.9c0.9-2.3,0.7-5-0.6-7.1s-3.6-3.6-6.1-3.8l-80.5-8L18.6,72.8l43.1-21.6l193.7,16.8 l93.2,33.9c0.7,0.2,1.4,0.4,2.1,0.5l93.8,7.8l-6,29.9l-56.1,24c-1.6,0.7-3,1.9-3.9,3.5l-42.8,77.1c-1.3,2.3-1.3,5.1-0.2,7.5 l14,27.9L329.8,293.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpain);
export default __webpack_public_path__ + "static/media/Spain.1a66e9df.svg";
export { ForwardRef as ReactComponent };